import type { ApiNode } from '@goalbuddy/client';
import { ListChecks } from 'lucide-react';
import type { ReactNode } from 'react';
import { Empty, Spinner } from '@/components/ui';
import { useStructure } from '@/lib/hooks';
import { NodeRow } from './node-row';

/** A flat list of nodes from anywhere in the tree, showing each node's parent. */
export function NodeList({
  nodes,
  loading,
  empty = 'Nothing here.',
  extra,
}: {
  nodes?: ApiNode[];
  loading?: boolean;
  empty?: ReactNode;
  extra?: (n: ApiNode) => ReactNode;
}) {
  const { data: structure } = useStructure();
  const titles = new Map((structure ?? []).map((n) => [n.id, n.title]));
  if (loading) return <Spinner />;
  if (!nodes?.length) return <Empty icon={<ListChecks size={20} />}>{empty}</Empty>;
  return (
    <div className="space-y-0.5">
      {nodes.map((n) => (
        <NodeRow
          key={n.id}
          node={n}
          showParent
          parentTitle={n.parent_id ? titles.get(n.parent_id) : null}
          extra={extra?.(n)}
        />
      ))}
    </div>
  );
}
